import { render, staticRenderFns } from "./participant-trigger-day-zero-modal.vue?vue&type=template&id=c024f5e2&scoped=true&"
import script from "./participant-trigger-day-zero-modal.vue?vue&type=script&lang=js&"
export * from "./participant-trigger-day-zero-modal.vue?vue&type=script&lang=js&"
import style0 from "../../../public/static/fonts.scss?vue&type=style&index=0&id=c024f5e2&scoped=true&lang=scss&"
import style1 from "./participant-trigger-day-zero-modal.vue?vue&type=style&index=1&id=c024f5e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c024f5e2",
  null
  
)

component.options.__file = "participant-trigger-day-zero-modal.vue"
export default component.exports